"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListDetailsIcon = void 0;
const react_1 = __importDefault(require("react"));
const Theme_1 = require("../../Theme/Theme");
const ListDetailsIcon = (_a) => {
    var props = __rest(_a, []);
    return (react_1.default.createElement("svg", Object.assign({ width: "20", height: "20", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        react_1.default.createElement("path", { d: "M6.66666 5H17.5", stroke: props.color || Theme_1.theme.palette.DARK_GRAY_80, strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }),
        react_1.default.createElement("path", { d: "M6.66666 10H17.5", stroke: props.color || Theme_1.theme.palette.DARK_GRAY_80, strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }),
        react_1.default.createElement("path", { d: "M6.66666 15H17.5", stroke: props.color || Theme_1.theme.palette.DARK_GRAY_80, strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }),
        react_1.default.createElement("path", { d: "M2.5 5H2.50875", stroke: props.color || Theme_1.theme.palette.DARK_GRAY_80, strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }),
        react_1.default.createElement("path", { d: "M2.5 10H2.50875", stroke: props.color || Theme_1.theme.palette.DARK_GRAY_80, strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }),
        react_1.default.createElement("path", { d: "M2.5 15H2.50875", stroke: props.color || Theme_1.theme.palette.DARK_GRAY_80, strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" })));
};
exports.ListDetailsIcon = ListDetailsIcon;
